<template>
  <card
    v-if="options.length"
    class="wide-card"
    page="login"
    style="overflow:visible;"
  >
    <label class="top-label">TELL US ABOUT YOUR CURRENT MENTAL HEALTH CONCERNS </label>
    <br />
    <label>This quick 2-minute survey will allow us to help match you with the best counselors and resources for your specific needs. (Please select all that apply)</label>
    <form-component>
      <form
        id="step-two"
        data-vv-scope="step-two"
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <input-button-list
          :value="selections || []"
          label=""
          :allow-two-stack="true"
          :multiple="true"
          :options="options"
          :force-full-width-inputs="true"
          @input="selection_buttons_change"
        />
        <div class="row mt-3">
          <div class="col-12 col-md-4 order-md-2">
            <button
              class="btn btn--primary"
              :disabled="saving"
              type="submit"
            >
              <span class="text-center">Continue</span>
              <span class="float-right">
                <font-awesome-icon v-if="!saving" :icon="['fas', 'arrow-right']" size="lg" />
                <font-awesome-icon
                  v-else
                  :spin="true"
                  :icon="['fas', 'spinner']"
                  class="icon alt"
                />
              </span>
            </button>
          </div>
          <div class="col-12 col-md-8 order-md-1" />
        </div>
      </form>
    </form-component>
  </card>
</template>

<script>
import InputButtonList from '@/components/inputs/InputButtonList.vue';
import FormComponent from '@/components/FormComponent.vue';
import Card from '@/components/Card.vue';
import UserClient from '@/api/UserClient';

export default {
    name: 'StruggleAreas',
    components: {
        InputButtonList,
        Card,
        FormComponent,
    },
    data() {
        return {
            userClient: new UserClient(this.$http),
            options: [],
            selections: [],
            other: null,
            saving: false
        }
    },
    async created() {
      const struggleAreas = await this.userClient.getSpecialtiesList('', 500);

      this.options = struggleAreas.results.map(struggle => ({
        id: struggle.id,
        display_label: struggle.name
      })) || [];
      this.options.push({ id: 0, display_label: 'Other' });
    },
    mounted() {
      const struggleAreas = this.$store.getters.currentUser.student_profile.struggle_areas || [];
      if (struggleAreas.length > 0) {
        this.selections = struggleAreas.map(x => x.id);
      }
    },
    methods:{
      selection_buttons_change(value) {
          this.selections = value
      },
      handleOtherFromStruggleSelections() {
        if (this.selections.includes(0)) {
          this.other = 'Other';
          this.selections = this.selections.filter(x => x !== 0)
        }
      },
      async save() {
        this.saving = true;

        this.handleOtherFromStruggleSelections();

        try {
          await this.userClient.setUserCounselorPreferences(
            this.$store.getters.currentUser.id,
            null,
            null,
            null,
            null,
            null,
            this.selections,
            this.other
          );

          this.$store.getters.currentUser.student_profile.struggle_areas = this.selections.map(x => ({ id: x }));
          this.$emit('complete', null);
        } catch (error) {
          this.$store.commit('setGlobalAlert', {
            msg: 'Failed to Save. Please try again!', error: true,
          });
        } finally {
          this.saving = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wide-card {
    max-width: 800px;
  }
</style>
